import { PropsWithChildren, useEffect, useMemo } from "react";

import { useDashboardUsersControllerMe } from "@/api/__generated__/dashboard-users/dashboard-users";
import { setSentryUser } from "@/lib/sentry";
import { mapToCurrentUser } from "@/mappers/user.mappers";

import { CurrentUserContext } from "./CurrentUserContext";

export const CurrentUserProvider = ({ children }: PropsWithChildren) => {
  const {
    data: userData,
    isPending: userLoading,
    refetch,
    error,
  } = useDashboardUsersControllerMe({
    query: {
      staleTime: 60_000,
    },
  });

  const currentUser = useMemo(() => (userData ? mapToCurrentUser(userData) : null), [userData]);

  useEffect(() => {
    if (currentUser) {
      setSentryUser({ id: String(currentUser.id), email: currentUser.email });
    } else {
      setSentryUser(null);
    }
  }, [currentUser]);

  const contextValue = useMemo(
    () => ({ currentUser, loading: userLoading, refetch, isError: !!error }),
    [currentUser, userLoading, refetch, error]
  );

  return <CurrentUserContext.Provider value={contextValue}>{children}</CurrentUserContext.Provider>;
};
